export default {
    title: "Položky nebyly doručeny",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "Děkuju",
        message: "Děkuji za vaši odpověď."
    },
    message: "Uvedli jste, že jste zásilku neobdrželi, přestože ji kurýr označil jako doručenou.",
    cta: "Pro pomoc s řešením problému prosím postupujte takto:",
    items: {
        1: {
            message: "Klikněte na odkaz(y) pro sledování:"
        },
        2: {
            message: "Zkontrolujte stav doručení. Zkontrolujte:",
            items: {
                1: "Kdo podepsal balíček",
                2: "Pokud bylo vráceno odesílateli",
                3: "Pokud balík čeká na vyzvednutí"
            }
        },
        3: {
            message: "Zkontrolujte, zda neobsahuje doručovací oznámení s uvedením, kde mohla být položka zanechána."
        },
        4: {
            message: "Zeptejte se sousedů, příbuzných a přátel, kteří si balík mohli převzít."
        }
    },
    question: "Pomohlo vám to vyřešit váš dotaz ohledně doručení? Máte nyní položku, nebo víte, kdo ji má? Odpovězte prosím níže.",
    product: {
        name: "Název položky",
        quantity: "Množství",
        tracking: "Sledování",
    },
    buttons: {
        yes: "Ano",
        no: "Žádný",
        saving: "Ukládání"
    }
}